<template>
  <div class="alert alert-light font-size-xs h-50px">
    Failed to load this section. The app may have been updated.
    <a
      class="alert-link"
      role="button"
      @click="refreshPage"
    >
      Refresh page to retry
    </a>
  </div>
</template>

<script setup>
function refreshPage() {
  window.location.reload()
}
</script>
